export const LOCATION_OPTIONS = [
  { value: 'Home', label: 'Home' },
  { value: 'Community', label: 'Community' },
];

export const DELIVERY_METHOD_OPTIONS = [
  { value: 'Telehealth', label: 'Telehealth' },
  { value: 'In-person', label: 'In-person' },
];

// Service codes the matrix supports (per FA-3331). Filter the loaded
// serviceCodes list to these for the dropdown.
export const MODIFIER_MATRIX_SERVICE_CODES = [
  '97151', '97152', '97153', '97155', '97156', '97157',
];

export const MODIFIER_MATRIX_SERVICE_CODE_LABELS = {
  '97151': 'Assessment - BCBA',
  '97152': 'Assessment - technician',
  '97153': 'Direct session',
  '97155': 'Client Supervision',
  '97156': 'Parent Supervision',
  '97157': 'Group Parent Training',
};
